module.exports = __webpack_public_path__ + "static/media/nasa.420e154e.png";